import { convertAvailableQty } from '@/utils/weightType'

export default {
  ingredientOptions: (state, _, rootState) => {
    return state.ingredients.reduce((coll, ing) => {
      if (state.inventory && state.inventory.id === ing.value) {
        return coll
      }
      let qty = ing.inventories_quantity
      const item = (state.inventory || { ingredients: [] }).ingredients.find(item => item.ingredientId === ing.value)
      if (item) {
        qty += convertAvailableQty(item.quantity, item.weight_type)[ing.inventories_weight_type]
      }
      qty = ((rootState.product.product || {}).product_inventories || []).reduce((sumQty, item) => {
        if (item.inventoryId === ing.value) {
          sumQty += convertAvailableQty(item.quantity, item.weight_type)[ing.inventories_weight_type]
        }
        return sumQty
      }, qty)
      if (qty > 0) {
        coll.push({
          ...ing,
          inventories_quantity: qty
        })
      }
      return coll
    }, [])
  }
}
